/** @jsxImportSource @emotion/react */

import Form from '@components/dialog/Form'
import { useForm } from 'react-hook-form'
import { css } from '@emotion/react'
import Text from '@components/field/Text'
import { useEffect, useState } from 'react'
import Select2 from '@components/field/Select2'
import useValue from './useValue'
import { indexApi } from '../ManageBanks/api'

const CSS = css`
  min-width: 829px;
  border-radius: 5px;
  .MuiDialogContent-root {
    padding: 32px;
  }
  .field-wrap {
    width: 381px;
    display: flex;
    flex-direction: column;
  }
  .field-wrap > div {
    flex: 1;
    margin-bottom: 10px;
  }
  .field-wrap .bank {
    display: flex;
    justify-content: space-between;
  }
  .field-wrap .bank > div {
    max-width: 48%;
  }
`

export default function Dialog(props) {
  const {
    type, title, onSave: save, defaultValues,
  } = props

  const { value, open } = useValue(defaultValues)
  const [banks, setBanks] = useState([])

  const getBanks = async () => {
    try {
      const { status, data: { data } } = await indexApi({ per_page: 100 })

      if (status === 'ok') {
        setBanks(data)
      } else {
        setBanks()
      }
    } catch (error) {
      setBanks()
    }
  }

  useEffect(() => {
    getBanks()
  }, [])

  const {
    handleSubmit, register, reset, control,
  } = useForm({
    defaultValues,
  })

  useEffect(() => {
    if (open) {
      reset(
        value,
        {
          isDirty: false,
          touched: false,
          dirtyFields: false,
          errors: false,
        }
      )
    }
  }, [value, reset, open])

  return (
    <Form
      title={title}
      type={type}
      onSubmit={handleSubmit((data) => save(data))}
      css={CSS}
    >
      <div className="field-wrap">
        {
          value?.id && (
            <input name="id" type="hidden" value={value.id} ref={register} />
          )
        }
        <Select2
          label="Pilih Bank"
          name="bank_name"
          control={control}
          selects={banks}
        />
        <div className="bank">
          <Text label="Nama" name="name" ref={register} />
          <Text label="No. Rekening" name="account_number" ref={register} />
        </div>
      </div>
    </Form>
  )
}
